import { Button } from '@etnas/design-system';
import { SignInForm } from './SignInForm';
import { useAuth } from '@/app/auth';

/**
 * Session lock (HF-008). Rendered above the still-mounted workspace (which is inert and blurred) so that
 * after the same person re-authenticates they continue exactly where they were. A different person is
 * signed in fresh with all cached data cleared.
 */
export function LockScreen() {
  const { lock, me, logout } = useAuth();
  if (!lock || !me) return null;
  return (
    <div className="ex-lock" role="dialog" aria-modal="true" aria-labelledby="lock-title">
      <div className="ex-auth-card">
        <div className="ex-auth-brand">
          <span className="ex-rail-mark" aria-hidden="true">E</span>
          <div>
            <div id="lock-title" className="ex-strong">
              {lock === 'idle' ? 'Locked after inactivity' : 'Your session ended'}
            </div>
            <div className="ex-caption ex-fg-muted">Your drafts are saved. Sign in to return to the same patient and place.</div>
          </div>
        </div>
        <SignInForm lockedUsername={me.user.username} audience={me.user.kind === 'patient' ? 'portal' : 'workforce'} onSignedIn={() => {}} />
        <Button variant="quiet" onClick={() => logout()}>
          Not {me.user.displayName}? Sign out
        </Button>
      </div>
    </div>
  );
}
